import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { Link } from '../Link/Link';
import { Type } from '../Type/Type';
/**
 * These advertiser disclosure messages stem from the canoncial marketplace
 * product types: https://github.com/NerdWallet/js-nw-api-sdk/blob/master/src/marketplace-sdk/constants.js#L35-L43
 */

export var PRODUCT_TYPES = {
  CREDIT_CARDS: 'credit_cards',
  INVESTING: 'investing'
};
var TYPES = [PRODUCT_TYPES.CREDIT_CARDS, PRODUCT_TYPES.INVESTING];
export var AdvertiserDisclosureMessage = function AdvertiserDisclosureMessage(_ref) {
  var type = _ref.type;

  switch (type) {
    case PRODUCT_TYPES.INVESTING:
      return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Type, {
        className: classes('margin-bottom-3')
      }, "NerdWallet, Inc. is an independent publisher and comparison service, not an investment advisor. Its articles, interactive tools and other content are provided to you for free, as self-help tools and for informational purposes only. They are not intended to provide investment advice. NerdWallet does not and cannot guarantee the accuracy or applicability of any information in regard to your individual circumstances. Examples are hypothetical, and we encourage you to seek personalized advice from qualified professionals regarding specific investment issues. Our estimates are based on past market performance, and past performance is not a guarantee of future performance."), /*#__PURE__*/React.createElement(Type, {
        className: classes('margin-bottom-3')
      }, "We believe everyone should be able to make financial decisions with confidence. And while our site doesn\u2019t feature every company or financial product available on the market, we\u2019re proud that the guidance we offer, the information we provide and the tools we create are objective, independent, straightforward \u2014 and free."), /*#__PURE__*/React.createElement(Type, {
        className: classes('margin-bottom-3')
      }, "So how do we make money? Our partners compensate us. This may influence which products we review and write about (and where those products appear on the site), but it in no way affects our recommendations or advice, which are grounded in thousands of hours of research. Our partners cannot pay us to guarantee favorable reviews of their products or services.", ' ', /*#__PURE__*/React.createElement(Link, {
        href: "https://www.nerdwallet.com/blog/our-partners/"
      }, "Here is a list of our partners"), "."));

    case PRODUCT_TYPES.CREDIT_CARDS:
      return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Type, {
        className: classes('margin-bottom-3')
      }, "We believe everyone should be able to make financial decisions with confidence. And while our site doesn\u2019t feature every company or financial product available on the market, we\u2019re proud that the guidance we offer, the information we provide and the tools we create are objective, independent, straightforward \u2014 and free."), /*#__PURE__*/React.createElement(Type, {
        className: classes('margin-bottom-3')
      }, "So how do we make money? Our partners compensate us. This may influence which products we review and write about (and where those products appear on the site), but it in no way affects our recommendations or advice, which are grounded in thousands of hours of research. Our partners cannot pay us to guarantee favorable reviews of their products or services.", ' ', /*#__PURE__*/React.createElement(Link, {
        href: "https://www.nerdwallet.com/blog/our-partners/"
      }, "Here is a list of our partners"), "."));

    default:
      return null;
  }
};
AdvertiserDisclosureMessage.displayName = 'AdvertiserDisclosureMessage';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  AdvertiserDisclosureMessage.propTypes = {
    type: PropTypes.oneOf(TYPES)
  };
}